import { FlightConfig } from '../store/schema/NinjaFlightsResponse';
import { action } from 'satcheljs';

const onFlightConfigSelected = action(
    'ON_FLIGHT_CONFIG_SELECTED',
    (flightConfig: FlightConfig) => ({
        flightConfig,
    })
);

export default onFlightConfigSelected;
